import { normalizeNamespace } from './client';

/**
 * Authors API service
 */
export class AuthorsApi {
  constructor(apiClient) {
    this.client = apiClient;
  }

  /**
   * Get paginated list of authors
   */
  getAuthors(namespace, params = {}) {
    const ns = normalizeNamespace(namespace);
    const {
      offset, limit, view, sortby, source, filter,
    } = params;
    const queryParams = {
      ...(offset !== undefined && { offset }),
      ...(limit !== undefined && { limit }),
      ...(view && { view }),
      ...(sortby && { sortby }),
      ...(source && { source }),
      ...(filter && { filter }),
    };
    return this.client.get(`/${ns}/authors`, queryParams);
  }

  /**
   * Get single author by ID with namespace
   */
  getAuthorById(namespace, authorId) {
    const ns = normalizeNamespace(namespace);
    return this.client.get(`/${ns}/authors/${authorId}`);
  }

  /**
   * Create new author
   */
  createAuthor(author) {
    return this.client.post('/private/authors', author);
  }

  /**
   * Bookmark a public author.
   */
  bookmarkAuthor(authorId) {
    return this.client.post('/private/authors', { id: authorId });
  }

  /**
   * Partially update an author (merge). Profiles in the body are merged into
   * the existing set; profiles omitted are preserved.
   */
  updateAuthor(namespace, authorId, patch) {
    const ns = normalizeNamespace(namespace);
    return this.client.patch(`/${ns}/authors/${authorId}`, patch);
  }

  /**
   * Replace an author (full update). The body carries the
   * complete profile list, so profiles omitted from it are removed.
   */
  replaceAuthor(namespace, authorId, author) {
    const ns = normalizeNamespace(namespace);
    if (ns === 'pending') {
      return this.client.patch(`/${ns}/authors/${authorId}`, author);
    }
    return this.client.put(`/${ns}/authors/${authorId}`, author);
  }

  /**
   * Delete author
   */
  deleteAuthor(namespace, authorId) {
    const ns = normalizeNamespace(namespace);
    return this.client.delete(`/${ns}/authors/${authorId}`);
  }

  /**
   * Share author (create pending copy for approval)
   */
  shareAuthor(authorId) {
    return this.client.post(`/pending/authors/${authorId}`);
  }

  /**
   * Merge source authors into the target author
   */
  mergeAuthors(namespace, targetAuthorId, sourceAuthorIds) {
    const ns = normalizeNamespace(namespace);
    return this.client.patch(`/${ns}/authors/${targetAuthorId}/merge`, { authorIds: sourceAuthorIds });
  }

  /**
   * Get author suggestions for autocomplete.
   */
  getSuggestions(namespace, searchTerm) {
    const ns = normalizeNamespace(namespace);
    return this.client.get(`/${ns}/authors/suggest`, { filter: searchTerm });
  }
}

export default AuthorsApi;
